import { render, staticRenderFns } from "./TagsOfSection.vue?vue&type=template&id=c8cbefa8&scoped=true&"
import script from "./TagsOfSection.ts?vue&type=script&lang=ts&"
export * from "./TagsOfSection.ts?vue&type=script&lang=ts&"
import style0 from "./TagsOfSection.scss?vue&type=style&index=0&id=c8cbefa8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8cbefa8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCheckbox,VIcon})
